import type { components } from '@luxuryescapes/contract-svc-promo/generated';

type definitions = components['schemas'];

const PROMO_BRANDS: ReadonlyArray<definitions['Promo Brands']> = [
  'luxuryescapes',
  'cudo',
  'deals',
  'treatme',
  'scooponexperience',
  'scoopontravel',
  'cudotravel',
  'dealstravel',
  'treatmetravel',
  'kogantravel',
  'lebusinesstraveller',
  'zoomzoom',
  'leagenthub',
  'leagenthub_cvfr',
];

const PROMO_BRAND_SET: ReadonlySet<string> = new Set(PROMO_BRANDS);

export function isPromoBrand(brand: string): brand is definitions['Promo Brands'] {
  return PROMO_BRAND_SET.has(brand);
}

export function toPromoBrand(brand?: string | null): definitions['Promo Brands'] | undefined {
  if (!brand) {
    return undefined;
  }
  return isPromoBrand(brand) ? brand : undefined;
}
